<template>
  <div id="reg_wrap">
    <div id="reg">
      <main-part :templateType="$route.name"/>
    </div>
    <footer-bar />
  </div>
</template>

<script>
const DEV = process.env.NODE_ENV === "development";
import { mapActions, mapGetters } from "vuex";
import MainPart from "@/components/MainPart";
import FooterBar from "@/components/FooterBar";
import router from "@/router/";
import { Message } from "element-ui";
export default {
  components: {
    FooterBar,
    MainPart
  },
  watch: {
    /**
     * routeの状態を監視
     * 意図せぬ遷移の場合はガード
     */
    $route(to, from) {
      if (from.name === "form" && to.name !== "thanks") {
        Message({
          message: "無効な操作です",
          type: "error"
        });
        router.push({ path: "/", query: router.history.current.query });
        return;
      }
    }
  },
  mounted() {
    // top以外で直にアクセスしてきた場合はエラーで返す
    if (!DEV && this.$route.name !== "form") {
      Message({
        message: "無効な操作です、再度読み込んでください",
        type: "error"
      });
      router.push({ path: "/", query: router.history.current.query });
      this.$store.commit("update", { code_error: true });
      this.$store.commit("update", { loading: false });
      return;
    }
    this.getRegistrationInfo();
  },
  created: function() {
    const self = this;
    // ブラウザバック、リロード時アラート
    if (!DEV) {
      window.onbeforeunload = function(event) {
        if (self.$route.name === "form") {
          setTimeout(function() {
            // gtag("event", "user_action", {
            //   event_category: "remain-input",
            //   event_label: "form",
            //   non_interaction: true
            // });
          }, 0);
        }
        event.returnValue =
          "このページから移動しますか？\n入力したデータは保存されません";
      };
    }
  },
  methods: {
    ...mapActions(["getRegistrationInfo"])
  },
  name: "registration"
};
</script>



// WEBPACK FOOTER //
// src/Registration.vue